export interface INewContact {
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string
}